




import { Component, Mixins, Prop } from "vue-property-decorator";
import { IKeyHandleable } from "./IKeyHandleable";

@Component
export default class PasteKeyHandler extends Mixins() implements IKeyHandleable {
  @Prop()
  pasted: () => boolean;

  handleKeyDowned(event: KeyboardEvent, isInputting: boolean, isTextSelecting: boolean): boolean {
    if (!event.ctrlKey || (event.key !== "v")) {
      return false;
    }
    if (isInputting) {
      return false;
    }
    return !!this.pasted
        && this.pasted();
  }

  handleKeyUpped(event: KeyboardEvent, isInputting: boolean, isTextSelecting: boolean): boolean {
    return false;
  }
}
